import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { $RenderConfig, $ServerContext } from '../atom';
import { UNSAFE_RemixContext } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { useContext, useMemo } from 'react';
import { UNSAFE_DataRouterStateContext } from 'react-router-dom';
import { StaticHead } from './head';
export const TAG_CSS_CHUNK_ID = 'data-css-chunk-id';
export const browserCssMetaList = [];
const generateIdFromHref = (href) => {
    try {
        const url = new URL(href, 'https://just-a-placeholder.com');
        return url.pathname;
    }
    catch (e) {
        return href;
    }
};
/**
 * @see https://github.com/remix-run/remix/blob/%40remix-run/react%401.17.1/packages/remix-react/components.tsx#L384
 */
const CssInlineLinks = () => {
    const { matches } = useContext(UNSAFE_DataRouterStateContext);
    const { enableSSRStyleInline } = useAtomValue($RenderConfig);
    const { manifest } = useContext(UNSAFE_RemixContext);
    const serverContext = useAtomValue($ServerContext);
    const cssMetaList = useMemo(() => {
        if (!enableSSRStyleInline) {
            return [];
        }
        const cssImports = matches.flatMap((match) => manifest.routes[match.route.id].cssImports);
        if (__BUILD_TARGET__ === 'client') {
            return browserCssMetaList;
        }
        return cssImports.map((href) => ({
            id: generateIdFromHref(href),
            content: serverContext.css[href],
        }));
    }, []);
    const cssCDNList = useMemo(() => {
        const cssCDNImports = matches
            .flatMap((match) => manifest.routes[match.route.id].cssImports)
            .map((href) => ({ id: generateIdFromHref(href), href }));
        const cssInlineList = cssMetaList.map((m) => m.id);
        return cssCDNImports.filter((i) => !cssInlineList.includes(i.id));
    }, [matches, cssMetaList]);
    if (__BUILD_TARGET__ === 'client') {
        // update link directly
        const links = document.querySelectorAll(`link[rel="stylesheet"][${TAG_CSS_CHUNK_ID}]`);
        const existingHrefs = Array.from(links).map((link) => link.getAttribute('href'));
        const newCdnLinks = cssCDNList.filter((item) => !existingHrefs.includes(item.href));
        if (newCdnLinks.length) {
            const newLinks = newCdnLinks.map((item) => {
                const linkElement = document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href = item.href;
                linkElement.setAttribute(TAG_CSS_CHUNK_ID, item.id);
                return linkElement;
            });
            document.head.append(...newLinks);
        }
    }
    return (_jsxs(StaticHead, { children: [cssMetaList.map((a) => (_jsx("style", { [TAG_CSS_CHUNK_ID]: a.id, dangerouslySetInnerHTML: { __html: a.content }, suppressHydrationWarning: true }, a.id))), cssCDNList.map((a) => (_jsx("link", { [TAG_CSS_CHUNK_ID]: a.id, rel: "stylesheet", href: a.href }, a.id)))] }));
};
export const Links = () => {
    return _jsx(CssInlineLinks, {});
};
